"use client";

import React from "react";
import MainBarSearch from "modules/common/components/mainbar/MainBarSearch";
import { SortSelect } from "modules/common/components/mainbar/SortSelect";
import { OrderSelect } from "modules/common/components/mainbar/OrderSelect";
import { MobileFilterBar } from "modules/common/components/MobileFilterBar";
import { SET_SORT_OPTIONS } from "modules/sets/constants/sortOptions";
import { SortOrderEnum } from "modules/collections/details/model/collection";
import { ArrowUpDown, Search } from "lucide-react";

const noop = () => {};

export function SetMainbarSkeleton() {
  return (
    <>
      {/* Mobile */}
      <div className="w-full md:hidden">
        <MobileFilterBar
          actions={[
            {
              icon: <Search size={16} />,
              label: "Search",
              onClick: noop,
            },
            {
              icon: <ArrowUpDown size={16} />,
              label: "Sort",
              onClick: noop,
            },
          ]}
        />
      </div>

      {/* Desktop */}
      <div className="hidden w-full md:block">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-end">
          <div className="flex w-full flex-col gap-2 self-start justify-self-start md:mr-auto md:w-fit md:flex-row">
            <MainBarSearch
              placeholder="Search for a card"
              onQueryChange={noop}
              className="hidden w-full max-w-2xl md:flex md:w-1/2"
            />
            <MainBarSearch
              placeholder="Search for a set"
              onQueryChange={noop}
              className="w-full max-w-2xl md:w-fit"
            />
          </div>
          <SortSelect
            options={SET_SORT_OPTIONS}
            currentIndex={2}
            onChange={noop}
          />
          <OrderSelect
            currentOrder={SortOrderEnum.Descending}
            onChange={noop}
          />
        </div>
      </div>
    </>
  );
}
